import Axios from 'axios';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { mask, unMask } from 'remask';
import AppCard from '../../../../components/appCard';
import { useInfo } from '../../../../context/infoContext';
import { Api } from '../../../../services/api';
import { userInfo } from '../../../../services/authHandlers';
import { ButtonPagueDefault } from '../../../../styles/primeReactConfig';


function Endereco() {
  const { control, register, handleSubmit, setValue } = useForm({
      defaultValues: {
        endereco_cep: null,
        endereco_estado: null,
        endereco_cidade: "",
        endereco_bairro: "",
        endereco_complemento: "",
        endereco_id: "",
        endereco_numero: "",
        endereco_rua: "",
      }
    });

  const {
    providerInfo
  } = useInfo();

  useEffect(() => {
    const { personal } = providerInfo
    //console.log(personal)
    if (personal.enderecos) {
      const {enderecos} = personal
      if(enderecos.length > 0){
        setValue("endereco_cep", mask(enderecos[0].endereco_cep, ['99999-999']))
        setValue("endereco_estado", enderecos[0].endereco_estado)
        setValue("endereco_cidade", enderecos[0].endereco_cidade)
        setValue("endereco_bairro", enderecos[0].endereco_bairro)
        setValue("endereco_complemento", enderecos[0].endereco_complemento)
        setValue("endereco_id", enderecos[0].endereco_id)
        setValue("endereco_numero", enderecos[0].endereco_numero)
        setValue("endereco_rua", enderecos[0].endereco_rua)
      }
    }
  }, [providerInfo])

  const updateAddress = async (values) => {
    //event.preventDefault()
    const addressData = {
      endereco_bairro: values.endereco_bairro,
      endereco_cep: unMask(values.endereco_cep),
      endereco_cidade: values.endereco_cidade,
      endereco_complemento: values.endereco_complemento,
      endereco_estado: values.endereco_estado,
      endereco_id: values.endereco_id,
      endereco_numero: values.endereco_numero,
      endereco_rua: values.endereco_rua,
      usuario_id: userInfo.usuario_id,
    }
    try {
      await Api.put('/users/update', addressData)
      toast.success('Endereço atualizado com sucesso')
    } catch (error) {
      console.log(error)
      toast.error('Erro ao atualizar endereço')
    }
  }

  const consultaCEP = async (e) => {
    try {
      const { data } = await Axios.get(`https://viacep.com.br/ws/${mask(e, '99999-999')}/json/`);
      if (data.erro === true) {
        toast.error("CEP não encontrado")
        setValue("endereco_estado", "");
        setValue("endereco_cidade", "");
        setValue("endereco_rua", "");
        setValue("endereco_bairro", "");
        setValue("endereco_numero", "");
        setValue("endereco_complemento", "");
      }
      else {
        setValue("endereco_estado", data.uf);
        setValue("endereco_cidade", data.localidade);
        setValue("endereco_rua", data.logradouro);
        setValue("endereco_bairro", data.bairro);
        setValue("endereco_numero", "");
        setValue("endereco_complemento", "");
        toast.success("CEP encontrado");
      }
    } catch (error) {
      console.log(error)
      toast.error('Serviço de verificação de CEP indisponível')
    }
  }


  return (
    <AppCard>
      <form onSubmit={handleSubmit(updateAddress)}>
        
        <div className='w-full grid gap-4'>
          <h4 className='text-xl'><b>Endereço</b></h4>
          <div className='grid grid-cols-1 md:grid-cols-2'>
              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_cep' className="w-full mb-2 md:w-5/12 md:mb-0">CEP</label>
                <div className='w-full md:w-7/12 grid'>
                  <Controller
                    name="endereco_cep"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <InputMask
                        id='endereco_cep'
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        required
                        mask='99999-999'
                        //unmask={true}
                        onComplete={e => consultaCEP(e.value)}
                      />)}
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_cidade' className="w-full mb-2 md:w-5/12 md:mb-0">Cidade</label>
                <div className='w-full md:w-7/12 grid'>
                  <InputText
                    {...register("endereco_cidade")}
                    id="endereco_cidade"
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_rua' className="w-full mb-2 md:w-5/12 md:mb-0">Rua</label>
                <div className='w-full md:w-7/12 grid'>
                  <InputText
                    {...register("endereco_rua")}
                    id="endereco_rua"
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_complemento' className="w-full mb-2 md:w-5/12 md:mb-0">Complemento</label>
                <div className='w-full md:w-7/12 grid'>
                  <InputText
                    {...register("endereco_complemento")}
                    id="endereco_complemento"
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_estado' className="w-full mb-2 md:w-5/12 md:mb-0">Estado</label>
                <div className='w-full md:w-7/12 grid'>
                  <Controller
                    name="endereco_estado"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <InputMask
                        id='endereco_estado'
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        required
                        mask="aa"
                      />)}
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_bairro' className="w-full mb-2 md:w-5/12 md:mb-0">Bairro</label>
                <div className='w-full md:w-7/12 grid'>
                  <InputText
                    {...register("endereco_bairro")}
                    id="endereco_bairro"
                  />
                </div>
              </div>

              <div className='grid md:flex p-3 items-center'>
                <label htmlFor='endereco_numero' className="w-full mb-2 md:w-5/12 md:mb-0">Número</label>
                <div className='w-full md:w-7/12 grid'>
                  <InputText
                    {...register("endereco_numero")}
                    id="endereco_numero"
                  />
                </div>
              </div>
          </div>
        </div>

        <div className="grid mt-3">
          <div className="w-full flex justify-center">
            <div className="grid w-full md:w-2/3 lg:w-1/3">
              <Button
                className='w-full'
                pt={ButtonPagueDefault}
                label="Enviar"
                type="submit"
              ></Button>
            </div>
          </div>
        </div>
      </form>
    </AppCard>
  )
}

export default Endereco